import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
  LocationPackageInterface,
  PackageInterface,
  PackageItem,
  PackageListType
} from 'types';

/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import api from '../api/packages.api';

export const packagesApi = createApi({
  reducerPath: 'packagesApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getPackagesByLocation: builder.query<
      LocationPackageInterface[],
      { locationId: number; promoId: number }
    >({
      queryFn: async ({ locationId, promoId }) => {
        try {
          const params =
            promoId === -1
              ? { locid: locationId }
              : { locid: locationId, pkg_label_id: promoId };
          const { data } = await api.getPackagesByLocId(params);

          return { data };
        } catch (error) {
          console.error(
            `Error while getting location packages: ${error.message}`
          );

          return { error };
        }
      }
    }),
    getPackages: builder.query<PackageInterface[], PackageListType>({
      queryFn: async (listType: PackageListType) => {
        try {
          const { data } = await api.getPackages(listType);

          return { data: data.data };
        } catch (error) {
          console.error(`Error while get client packages: ${error.message}`);

          return { error };
        }
      }
    }),
    getPackageItems: builder.query<PackageItem[], number>({
      queryFn: async (packageId: number) => {
        try {
          const { data } = await api.getPackageItems(packageId);

          return { data };
        } catch (error) {
          console.error(
            `Error while get client package items: ${error.message}`
          );

          return { error };
        }
      }
    })
  })
});

export const {
  useGetPackagesByLocationQuery,
  useGetPackagesQuery,
  useGetPackageItemsQuery
} = packagesApi;
